"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var withPolyfill_1 = __importDefault(require("react-resize-detector/build/withPolyfill"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var DashboardTypes_1 = require("./DashboardTypes");
var DragStore_1 = __importStar(require("./Stores/DragStore"));
var ListLayout_1 = __importDefault(require("./Layout/ListLayout"));
var Navigation_1 = __importDefault(require("./Navigation/Navigation"));
var StringManipulater_1 = require("Utils/StringManipulater");
var ActionTray_1 = __importDefault(require("./ActionTray/ActionTray"));
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var DragLabel_1 = __importDefault(require("./DragLabel/DragLabel"));
var Telemetry_1 = require("Telemetry");
var Sidebar_1 = __importDefault(require("./Sidebar/Sidebar"));
var MobileSidebar_1 = require("./Sidebar/MobileSidebar");
var DashboardUtils_1 = require("./DashboardUtils");
var EventUtils_1 = require("Utils/EventUtils");
var SetDragImage_1 = require("./SetDragImage");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var ResourceMover_1 = require("./ResourceMover/ResourceMover");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var FolderNameInput_1 = require("Dashboard/FolderNameInput/FolderNameInput");
var DashboardTypes_2 = require("@CommonFrontendBackend/Dashboard/DashboardTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var FoldersTelemetry_1 = require("./FoldersTelemetry");
var DashboardBlockLibrary_1 = require("Dashboard/DashboardBlockLibrary/DashboardBlockLibrary");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var TelemetryEnums_1 = require("Telemetry/TelemetryEnums");
var DashboardTelemetryService_1 = require("./DashboardTelemetry/DashboardTelemetryService");
var ReportsHome_1 = require("Reports/ReportsHome");
var EngagementLibrary_1 = require("Library/EngagementLibrary/EngagementLibrary");
var DesktopContainer_1 = require("./Sidebar/DesktopContainer");
var TemplateManagementDashboard_1 = require("Dashboard/TemplateManagementDashboard/TemplateManagementDashboard");
var TemplatesApiService_1 = require("Dashboard/TemplateManagementDashboard/TemplatesApiService");
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var AutomationLibrary_1 = require("Library/AutomationLibrary/AutomationLibrary");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var PageDashboardOnboardingBanner_1 = __importDefault(require("Dashboard/OnboardingBanner/PageDashboardOnboardingBanner"));
var KeyCodes;
(function (KeyCodes) {
    KeyCodes[KeyCodes["Escape"] = 27] = "Escape";
    KeyCodes[KeyCodes["Delete"] = 8] = "Delete";
    KeyCodes[KeyCodes["A"] = 65] = "A";
})(KeyCodes || (KeyCodes = {}));
var COMPACT_LAYOUT_BREAKPOINT = 900;
var BASE_CLASS_NAME = "dashboard";
exports.BASE_CLASS_NAME = BASE_CLASS_NAME;
var Dashboard = (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard(props) {
        var _this = _super.call(this, props) || this;
        _this.displayAllResults = function (triggerType) {
            _this.selectionStore.deselectAll();
            _this.dashboardViewStore.setIsShowingAllSearchResults(true);
            _this.projectListStore.setSearchTerm(_this.props.searchStore.searchTerm);
            _this.props.dashboardTelemetryService.trackSearchFilter(triggerType);
        };
        _this.backToStandardDashboard = function () {
            _this.onClearDashboard(false);
        };
        _this.onClearDashboard = function (openInNewTab) {
            if (openInNewTab) {
                window.open("/#/pages", "_blank");
            }
            else {
                var folderSelectionViewStore = _this.props.dashboardViewStore.folderSelectionViewStore;
                folderSelectionViewStore.setSelectedFolder(DashboardTypes_2.ProjectCollection.All);
                _this.clearTransientState();
                _this.projectListStore.clearSelectedFilters();
                _this.props.dashboardController.$state.go("dashboard", { nav: "pages" });
            }
        };
        _this.renderTopButtons = function () {
            if (_this.dashboardViewStore.isShowingAllSearchResults ||
                _this.projectListStore.blueprintParentId ||
                _this.projectListStore.selectedFolder === DashboardTypes_2.ProjectCollection.Archived ||
                _this.projectListStore.selectedFolder === DashboardTypes_2.ProjectCollection.Deleted) {
                return null;
            }
            else {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.OptionMenu, { className: "".concat(BASE_CLASS_NAME, "__create-menu"), size: "small", button: react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return _this.props.dashboardTelemetryService.trackCreateNewClicked(); }, decorator: kaleidoscope_1.ButtonDecorator.Dropdown }, "Create new") },
                        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: _this.handleBlankPageButtonClick }, "Blank Page"),
                        react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: _this.handleTemplateButtonClick }, "From Template"),
                        _this.props.usingFeature(FeatureFlag_1.default.DocConverter) && (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: _this.handleDocConversionButtonClick }, "Doc Conversion")),
                        _this.isUserFolderSelected && (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { onClick: _this.handleCreateFolderButtonClick }, "Folder")))));
            }
        };
        _this.stopPropagation = function (event) { return event.stopPropagation(); };
        _this.navbarClicked = function (event) {
            _this.props.rootDataStore.userDataStore.useHistoryDataStore.newFeaturesIndicatorStore.hideNewFeatureIndicator(UseHistoryTypes_1.NewFeatureIndicatorName.AutomationsLibrary);
            _this.stopPropagation(event);
        };
        _this.renderDragger = function () {
            if (!_this.dragStore.isDragging) {
                return;
            }
            var _a = _this.dragStore, top = _a.top, left = _a.left, width = _a.width, height = _a.height, dragType = _a.dragType;
            if (dragType === DragStore_1.DragType.Rectangle) {
                return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__dragger"), style: {
                        left: left,
                        top: top,
                        width: width,
                        height: height,
                    } }));
            }
        };
        _this.startDashboardDragging = function (event) {
            _this.startDrag(event, DragStore_1.DragType.Rectangle);
        };
        _this.startDrag = function (event, dragType) {
            if (!(0, EventUtils_1.isPrimaryButton)(event)) {
                return;
            }
            _this.dashboardViewStore.closeAllMenus();
            var containerRect = _this.dashboardContainerRef.current.getBoundingClientRect();
            _this.dragStore.startDrag(event.clientX, event.clientY, containerRect, dragType);
            document.addEventListener("mousemove", _this.drag);
            document.addEventListener("touchmove", _this.drag);
        };
        _this.drag = function (event) {
            _this.dragStore.moveFocus(event.clientX, event.clientY);
        };
        _this.stopDashboardDragging = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                document.removeEventListener("mousemove", this.drag);
                document.removeEventListener("touchmove", this.drag);
                if (!this.projectListStore.isLoadingProjects && this.dragStore.isDragging) {
                    if (this.dragStore.dragType === DragStore_1.DragType.Rectangle) {
                        this.selectionStore.setSelectingToSelected(event.ctrlKey || event.metaKey);
                    }
                    (0, mobx_1.runInAction)(function () {
                        _this.dragStore.stopDrag();
                    });
                }
                return [2];
            });
        }); };
        _this.handleKey = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var code, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (event.target.tagName !== "BODY") {
                            return [2];
                        }
                        code = event.keyCode || event.which;
                        _a = code;
                        switch (_a) {
                            case KeyCodes.Delete: return [3, 1];
                            case KeyCodes.Escape: return [3, 3];
                            case KeyCodes.A: return [3, 4];
                        }
                        return [3, 5];
                    case 1: return [4, this.projectListStore.deleteProjects(this.selectionStore.selected)];
                    case 2:
                        _b.sent();
                        this.selectionStore.deselectAll();
                        return [3, 5];
                    case 3:
                        this.selectionStore.deselectAll();
                        return [3, 5];
                    case 4:
                        if (event.ctrlKey || event.metaKey) {
                            this.selectionStore.selectAll();
                            event.preventDefault();
                        }
                        return [3, 5];
                    case 5: return [2];
                }
            });
        }); };
        _this.handleDocConversionButtonClick = function () {
            if (_this.props.usingFeature(FeatureFlag_1.default.DocConverter)) {
                return _this.dashboardController.uploadDocFile();
            }
        };
        _this.handleBlankPageButtonClick = function () {
            if (_this.dashboardViewStore.selectedFolder === DashboardTypes_2.ProjectCollection.Archived ||
                _this.dashboardViewStore.selectedFolder === DashboardTypes_2.ProjectCollection.Deleted) {
                throw new Error("Cannot create a blank page in the ".concat(_this.dashboardViewStore.selectedFolder, " folder"));
            }
            _this.props.dashboardTelemetryService.trackCreateNewResourceClicked(DashboardTelemetryService_1.CreateNewResourceTelemetryType.BlankPage);
            if (_this.dashboardViewStore.selectedFolder === DashboardTypes_2.ProjectCollection.All) {
                return _this.dashboardController.createNewProject();
            }
            return _this.dashboardController.createNewProject(_this.dashboardViewStore.selectedFolder);
        };
        _this.handleCreateFolderButtonClick = function () {
            _this.props.dashboardTelemetryService.trackCreateNewResourceClicked(DashboardTelemetryService_1.CreateNewResourceTelemetryType.Folder);
            if (_this.dashboardViewStore.selectedFolder) {
                return _this.dashboardViewStore.dashboardFoldersViewStore.foldersDataStore.createFolder("New folder", FoldersTelemetry_1.FolderCreatedOrigin.RightPanelButton, _this.dashboardViewStore.selectedFolder, true, { account: Types_1.Action.All });
            }
        };
        _this.handleTemplateButtonClick = function () {
            _this.props.dashboardTelemetryService.trackCreateNewResourceClicked(DashboardTelemetryService_1.CreateNewResourceTelemetryType.PageFromTemplate);
            return _this.dashboardController.goToTemplates();
        };
        _this.handleViewBlueprintChildren = function (blueprint) {
            _this.props.dashboardViewStore.folderSelectionViewStore.setSelectedFolder(null);
            _this.projectListStore.setBlueprintParent(blueprint);
            _this.props.dashboardTelemetryService.trackViewBlueprintChildren();
        };
        _this.stopAndDeselect = function () {
            _this.selectionStore.deselectAll();
            _this.dragStore.stopDrag();
        };
        _this.dashboardRef = react_1.default.createRef();
        _this.dashboardContainerRef = react_1.default.createRef();
        _this.projectDragLabelRef = react_1.default.createRef();
        _this.dashboardViewStore = props.dashboardViewStore;
        _this.dragStore = new DragStore_1.default();
        _this.projectListStore = props.projectListStore;
        _this.selectionStore = props.projectListStore.getSelectionStore();
        _this.dashboardController = props.dashboardController;
        var foldersTelemetry = new FoldersTelemetry_1.FoldersTelemetry(props.telemetry);
        _this.resourceMover = new ResourceMover_1.ResourceMover(props.projectListStore, foldersTelemetry);
        _this.accountIntegrationsDataStore = props.rootDataStore.getAccountIntegrationsDataStore();
        _this.onResourceCardClick = _this.onResourceCardClick.bind(_this);
        return _this;
    }
    Object.defineProperty(Dashboard.prototype, "numSelectedProjects", {
        get: function () {
            return this.projectListStore.getProjectStoresByIndexes(this.selectionStore.selected).length;
        },
        enumerable: false,
        configurable: true
    });
    Dashboard.prototype.componentDidMount = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        this.props.rootDataStore.getAccountDataStore().getTeamDataStore().fetchData();
        window.document && window.document.addEventListener("keydown", this.handleKey);
        this.disposeSubscriptionToFolderDataHasLoaded = (0, mobx_1.reaction)(function () { return _this.props.dashboardViewStore.dashboardFoldersViewStore.foldersDataStore.hasLoaded; }, function (hasLoaded) {
            if (hasLoaded) {
                _this.tryOpenLastSelectedFolder();
            }
        }, { fireImmediately: true });
        var _g = this.props, savedBlockLibraryViewStore = _g.savedBlockLibraryViewStore, savedBlocksFolderViewStore = _g.savedBlocksFolderViewStore, dashboardTelemetryService = _g.dashboardTelemetryService;
        if (((_c = (_b = (_a = this.props.dashboardController) === null || _a === void 0 ? void 0 : _a.$state) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.nav) === "blocks") {
            var savedBlockParams = (_f = (_e = (_d = this.props.dashboardController) === null || _d === void 0 ? void 0 : _d.$state) === null || _e === void 0 ? void 0 : _e.params) === null || _f === void 0 ? void 0 : _f.savedBlockParams;
            if (Object.keys(savedBlockParams).length !== 0) {
                var folder = savedBlockParams.currentFolder;
                if (folder !== savedBlockLibraryViewStore.currentFolder) {
                    savedBlockLibraryViewStore.filterSavedBlocksByFolderId(folder, false);
                }
                savedBlocksFolderViewStore.folderSelectionStore.setSelectedFolder(folder);
                savedBlockLibraryViewStore.restoreFilterAndSearchStates(savedBlockParams);
            }
            else {
                savedBlocksFolderViewStore.folderSelectionStore.setSelectedFolder(DashboardTypes_2.SavedBlockCollection.All);
                savedBlockLibraryViewStore.filterSavedBlocksByFolderId(DashboardTypes_2.SavedBlockCollection.All);
            }
            dashboardTelemetryService.trackDashboardViewed(DashboardTelemetryService_1.DashboardResourceTelemetryType.Blocks);
        }
        else {
            this.props.dashboardTelemetryService.trackDashboardViewed(DashboardTelemetryService_1.DashboardResourceTelemetryType.Pages);
        }
    };
    Dashboard.prototype.componentWillUnmount = function () {
        window.document && window.document.removeEventListener("keydown", this.handleKey);
        this.props.dashboardTelemetryService.stopTrackingFilter();
        this.disposeSubscriptionToFolderDataHasLoaded();
    };
    Dashboard.prototype.render = function () {
        var _a;
        var _this = this;
        var _b, _c;
        var dashboardViewStore = this.props.dashboardViewStore;
        return (react_1.default.createElement("div", { ref: this.dashboardRef, className: (0, classnames_1.default)(BASE_CLASS_NAME, (_a = {},
                _a["".concat(BASE_CLASS_NAME, "--loading")] = this.projectListStore.isLoadingProjects,
                _a)) },
            react_1.default.createElement(withPolyfill_1.default, { handleWidth: true, handleHeight: false, onResize: this.onResize, refreshMode: "throttle", refreshRate: 500 }),
            react_1.default.createElement(Navigation_1.default, { projectService: this.dashboardController.projectService, searchStore: this.props.searchStore, trial: this.dashboardController.trial, initSubscription: this.dashboardController.initSubscription, telemetry: this.props.telemetry, projectLimit: this.dashboardController.projectLimit, projectLiveLimit: this.dashboardController.projectLiveLimit, user: this.props.user, "$state": this.dashboardController.$state, openBrandSetup: this.dashboardController.openBrandSetup, publicApiBaseUrl: this.dashboardController.publicApiBaseUrl, rolesService: this.props.rolesService, dashboardViewStore: dashboardViewStore, displayAllResults: this.displayAllResults, onMouseDown: this.navbarClicked, onViewChildren: function (id, name) {
                    return _this.handleViewBlueprintChildren({
                        _id: id,
                        name: name,
                    });
                }, onClearDashboard: this.onClearDashboard, isMobile: this.useCompactLayout }),
            this.useCompactLayout && (react_1.default.createElement(MobileSidebar_1.MobileSidebar, { "$state": this.dashboardController.$state, onFolderSelect: this.onFolderSelect, folderSelectionViewStore: dashboardViewStore.folderSelectionViewStore, foldersViewStore: dashboardViewStore.dashboardFoldersViewStore, dragDropOnFolder: this.dragDropOnFolder, isMobileSidebarOpen: dashboardViewStore.isMobileSidebarOpen, setIsMobileSidebarOpen: dashboardViewStore.setIsMobileSidebarOpen, activeNav: ((_c = (_b = this.props.dashboardController.$state) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.nav) || "pages" })),
            this.renderActiveComponent()));
    };
    Dashboard.prototype.renderSavedBlocks = function () {
        var _a = this.props, user = _a.user, rolesService = _a.rolesService, telemetry = _a.telemetry;
        var hiddenCreateOptions = [];
        if (!this.props.usingFeature(FeatureFlag_1.default.Accept)) {
            hiddenCreateOptions.push(BlockTypes_1.BlockType.Accept);
        }
        if (!this.props.usingFeature(FeatureFlag_1.default.Quote)) {
            hiddenCreateOptions.push(BlockTypes_1.BlockType.Quote);
        }
        var userIsAdmin = rolesService.isAdmin(user);
        telemetry.debouncedTrack("Saved Block Library Viewed", {
            saved_block_origin: TelemetryEnums_1.SavedBlockOrigin.Dashboard,
        });
        return (react_1.default.createElement("div", { ref: this.dashboardContainerRef, className: "".concat(BASE_CLASS_NAME, "__container"), onMouseDown: this.startDashboardDragging, onMouseUp: this.stopDashboardDragging },
            react_1.default.createElement(DashboardBlockLibrary_1.DashboardBlockLibrary, { usingFeature: this.props.usingFeature, savedBlocksFolderViewStore: this.props.savedBlocksFolderViewStore, dashboardController: this.dashboardController, viewStore: this.props.savedBlockLibraryViewStore, userIsAdmin: userIsAdmin, hiddenCreateOptions: hiddenCreateOptions, telemetry: this.props.telemetry })));
    };
    Dashboard.prototype.renderPages = function () {
        var dashboardViewStore = this.props.dashboardViewStore;
        var folderSelectionViewStore = dashboardViewStore.folderSelectionViewStore;
        var isAdmin = this.props.rootDataStore.userDataStore.isAdmin;
        return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__container"), ref: this.dashboardContainerRef, onMouseDown: this.startDashboardDragging, onMouseUp: this.stopDashboardDragging },
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__onboarding-banner"), onMouseDown: this.stopPropagation },
                react_1.default.createElement(PageDashboardOnboardingBanner_1.default, null)),
            react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__content") },
                !this.useCompactLayout && (react_1.default.createElement(DesktopContainer_1.DesktopContainer, null,
                    react_1.default.createElement(Sidebar_1.default, { onFolderSelect: this.onFolderSelect, folderSelectionViewStore: folderSelectionViewStore, foldersViewStore: dashboardViewStore.dashboardFoldersViewStore, dragDropOnFolder: this.dragDropOnFolder }))),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__main") },
                    react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__top-controls space-between") },
                        react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__top-dropdown"), onMouseDown: this.stopPropagation }, this.renderTopTitle()),
                        react_1.default.createElement(ReactCSSTransitionGroup, { transitionName: "top-buttons-transition", transitionEnterTimeout: kaleidoscope_2.AnimationDuration.Medium, transitionLeaveTimeout: kaleidoscope_2.AnimationDuration.Medium }, this.numSelectedProjects === 0 && (react_1.default.createElement("div", { key: "top-buttons", className: "".concat(BASE_CLASS_NAME, "__top-buttons"), onMouseDown: this.stopPropagation }, !this.useCompactLayout && this.renderTopButtons())))),
                    react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__action-row dashboard-sticky-action-row") },
                        react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__action-row-inner") },
                            react_1.default.createElement(ReactCSSTransitionGroup, { transitionEnterTimeout: kaleidoscope_2.AnimationDuration.Long, transitionLeaveTimeout: kaleidoscope_2.AnimationDuration.Long, transitionName: "action-tray-transition", component: react_1.default.Fragment },
                                react_1.default.createElement(ActionTray_1.default, { key: "action-tray", dashboardController: this.dashboardController, projectListStore: this.projectListStore, dashboardViewStore: this.dashboardViewStore, selectionStore: this.selectionStore, numSelectedProjects: this.numSelectedProjects, isAdmin: isAdmin })))),
                    react_1.default.createElement(ListLayout_1.default, { selectionStore: this.selectionStore, dragStore: this.dragStore, projectListStore: this.projectListStore, dashboardController: this.dashboardController, dashboardViewStore: this.dashboardViewStore, numSelectedProjects: this.numSelectedProjects, onViewChildrenClick: this.handleViewBlueprintChildren, onResourceCardClick: this.onResourceCardClick, resourceDragStart: this.resourceDragStart, dashboardRef: this.dashboardRef, isAdmin: isAdmin }),
                    this.renderDragger(),
                    this.renderProjectDragLabel))));
    };
    Dashboard.prototype.renderActiveComponent = function () {
        var _a, _b;
        var _c = this.props, projectListStore = _c.projectListStore, user = _c.user, dashboardController = _c.dashboardController, rootDataStore = _c.rootDataStore, modal = _c.modal, notifyUser = _c.notifyUser;
        var activeNav = ((_b = (_a = dashboardController.$state) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.nav) || "pages";
        switch (activeNav) {
            case "reports": {
                var accountDataStore = rootDataStore.getAccountDataStore();
                var timezone = accountDataStore.getAccountTimezone();
                return (react_1.default.createElement(ReportsHome_1.ReportsHome, { sessionUser: user, usersList: projectListStore.userList, apiBaseUrl: dashboardController.apiBaseUrl, timezone: timezone, telemetry: this.props.telemetry }));
            }
            case "engagement-library":
                return react_1.default.createElement(EngagementLibrary_1.EngagementLibrary, null);
            case "blocks":
                return this.renderSavedBlocks();
            case "templates":
                var inlinePromptsHistoryStore = rootDataStore.userDataStore.useHistoryDataStore.inlinePromptsHistoryStore;
                if (!this.props.rolesService.isAdmin(user)) {
                    this.backToStandardDashboard();
                }
                return (react_1.default.createElement(TemplateManagementDashboard_1.TemplateManagementDashboard, { apiService: new TemplatesApiService_1.TemplatesApiService(dashboardController.apiBaseUrl), dashboardController: dashboardController, modalService: modal, userList: projectListStore.userList, accountIntegrationsDataStore: this.accountIntegrationsDataStore, notifyUser: notifyUser, promptsStore: inlinePromptsHistoryStore, usingFeature: this.props.usingFeature }));
            case "automations":
                if (!this.props.rolesService.isAdmin(user) || !this.props.usingFeature(FeatureFlag_1.default.HubspotSyncEssentials)) {
                    this.backToStandardDashboard();
                }
                return react_1.default.createElement(AutomationLibrary_1.AutomationLibrary, null);
            case "pages":
            default:
                return this.renderPages();
        }
    };
    Object.defineProperty(Dashboard.prototype, "renderProjectDragLabel", {
        get: function () {
            return (react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__drag-label") },
                react_1.default.createElement(DragLabel_1.default, { divRef: this.projectDragLabelRef, text: (0, StringManipulater_1.pluralise)(this.numSelectedProjects, "page") })));
        },
        enumerable: false,
        configurable: true
    });
    Dashboard.prototype.onResize = function (width) {
        this._componentWidth = width;
    };
    Object.defineProperty(Dashboard.prototype, "useCompactLayout", {
        get: function () {
            return this._componentWidth != null && this._componentWidth <= COMPACT_LAYOUT_BREAKPOINT;
        },
        enumerable: false,
        configurable: true
    });
    Dashboard.prototype.clearTransientState = function () {
        this.selectionStore.deselectAll();
        this.dashboardViewStore.setIsShowingAllSearchResults(false);
        this.projectListStore.clearSearchTerm();
        this.projectListStore.clearBlueprintParent();
        this.projectListStore.resetPageNumber();
    };
    Dashboard.prototype.tryOpenLastSelectedFolder = function () {
        var folder = (0, DashboardUtils_1.getSavedFolderId)();
        if (folder && this.folderExistsInDashboard(folder)) {
            this.onFolderSelect(folder);
            this.props.dashboardTelemetryService.trackRememberedFolder(folder);
        }
        else if (!this.folderExistsInDashboard(folder)) {
            (0, DashboardUtils_1.deleteSavedFolderId)();
        }
        this.props.dashboardTelemetryService.startTrackingFilter(this.projectListStore);
    };
    Dashboard.prototype.folderExistsInDashboard = function (folderId) {
        if ((0, DashboardUtils_1.isASystemFolder)(folderId)) {
            return true;
        }
        return (this.dashboardViewStore.dashboardFoldersViewStore.foldersDataStore.allFolders.find(function (x) { return x.id === folderId; }) !==
            undefined);
    };
    Dashboard.prototype.renderTopTitle = function () {
        var _a = this.projectListStore, projectCount = _a.projectCount, searchTerm = _a.searchTerm;
        if (this.dashboardViewStore.isShowingAllSearchResults) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__back"), onClick: this.backToStandardDashboard },
                    react_1.default.createElement(icons_1.ArrowLeft, { size: icons_1.IconSize.Small }),
                    react_1.default.createElement("span", { className: "label label--lighter label--large" }, "Back to all")),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__heading ").concat(BASE_CLASS_NAME, "__heading--with-quote text-h2") },
                    react_1.default.createElement("span", null,
                        (0, StringManipulater_1.pluralise)(projectCount, "search result"),
                        " for \u201C",
                        searchTerm))));
        }
        else if (this.projectListStore.blueprintParentId) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__back"), onClick: this.backToStandardDashboard },
                    react_1.default.createElement(icons_1.ArrowLeft, { size: icons_1.IconSize.Small }),
                    react_1.default.createElement("span", { className: "label label--lighter label--large" }, "Back to all")),
                react_1.default.createElement("div", { className: "".concat(BASE_CLASS_NAME, "__heading ").concat(BASE_CLASS_NAME, "__heading--with-quote text-h2") },
                    react_1.default.createElement("span", null,
                        (0, StringManipulater_1.pluralise)(projectCount, "page"),
                        " created from \u201C",
                        this.projectListStore.blueprintParentName))));
        }
        else {
            var isDisabled = (0, DashboardUtils_1.isASystemFolder)(this.props.dashboardViewStore.folderSelectionViewStore.selectedFolder);
            var dashboardFoldersViewStore = this.props.dashboardViewStore.dashboardFoldersViewStore;
            var maxLength = !!dashboardFoldersViewStore ? dashboardFoldersViewStore.maxNameLength : undefined;
            return (react_1.default.createElement(FolderNameInput_1.FolderNameInput, { key: this.projectListStore.selectedFolder, isDisabled: isDisabled, folderName: this.getFolderTitle(this.projectListStore.selectedFolder), folderId: this.projectListStore.selectedFolder, changeFolderName: isDisabled ? undefined : this.props.dashboardFoldersDataStore.updateFolderName, maxLength: maxLength }));
        }
    };
    Dashboard.prototype.getFolderTitle = function (folderId) {
        if ((0, DashboardUtils_1.isASystemFolder)(folderId)) {
            return (0, DashboardUtils_1.getTitle)(folderId);
        }
        else {
            return this.dashboardViewStore.dashboardFoldersViewStore.getFolderName(folderId);
        }
    };
    Object.defineProperty(Dashboard.prototype, "isUserFolderSelected", {
        get: function () {
            return !(0, DashboardUtils_1.isASystemFolder)(this.dashboardViewStore.selectedFolder);
        },
        enumerable: false,
        configurable: true
    });
    Dashboard.prototype.onResourceCardClick = function (event, index) {
        return __awaiter(this, void 0, Promise, function () {
            var clickedStore, restored;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.shiftKey) return [3, 1];
                        this.selectionStore.expandSelectionToIndex(index);
                        return [3, 9];
                    case 1:
                        if (!(this.selectionStore.isOnlySelected(index) || !this.selectionStore.isAnythingSelected)) return [3, 8];
                        clickedStore = this.props.projectListStore.projectStores[index];
                        if (!(clickedStore.type === "ProjectStore")) return [3, 5];
                        if (!(event.ctrlKey || event.metaKey)) return [3, 2];
                        window.open("/#/page/".concat(clickedStore._id), "_blank");
                        return [3, 4];
                    case 2: return [4, this.dashboardController.openProject(clickedStore, this.projectListStore.isFiltered ? Telemetry_1.ProjectOpenedOrigin.DashboardFiltered : Telemetry_1.ProjectOpenedOrigin.Dashboard)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        this.props.dashboardTelemetryService.trackOpenProjectIntent();
                        return [3, 7];
                    case 5: return [4, this.dashboardController.restoreWithModal(clickedStore)];
                    case 6:
                        restored = _a.sent();
                        if (restored) {
                            this.projectListStore.forceFetchProjects();
                        }
                        _a.label = 7;
                    case 7: return [3, 9];
                    case 8:
                        if (event.ctrlKey || event.metaKey) {
                            this.selectionStore.toggleIndexSelected(index);
                        }
                        else {
                            this.selectionStore.deselectAll();
                        }
                        _a.label = 9;
                    case 9: return [2];
                }
            });
        });
    };
    Dashboard.prototype.onFolderSelect = function (selectedFolder) {
        var folderSelectionViewStore = this.props.dashboardViewStore.folderSelectionViewStore;
        if (selectedFolder !== folderSelectionViewStore.selectedFolder) {
            this.clearTransientState();
            (0, DashboardUtils_1.setSavedFolderId)(selectedFolder);
        }
        this.stopAndDeselect();
        folderSelectionViewStore.setSelectedFolder(selectedFolder);
        this.props.dashboardTelemetryService.trackDashboardFolderSelected(selectedFolder);
    };
    Dashboard.prototype.resourceDragStart = function (event, index) {
        event.dataTransfer.effectAllowed = "move";
        var dragData = {
            type: DashboardTypes_1.DragDataType.ResourceCards,
        };
        event.dataTransfer.setData("application/json", JSON.stringify(dragData));
        if (!this.selectionStore.isSelected(index)) {
            this.selectionStore.deselectAll();
            this.selectionStore.selectIndex(index);
        }
        (0, SetDragImage_1.setDragImage)(event, this.projectDragLabelRef.current);
        this.dashboardViewStore.closeProjectActionMenu();
    };
    Dashboard.prototype.dragDropOnFolder = function (event, folderId) {
        var dragData;
        var rawDragData = event.dataTransfer.getData("application/json");
        try {
            dragData = JSON.parse(rawDragData);
        }
        catch (e) {
        }
        if (!!dragData) {
            switch (dragData.type) {
                case DashboardTypes_1.DragDataType.ResourceCards:
                    this.moveSelectedProjectsToFolder(folderId);
                    break;
                case DashboardTypes_1.DragDataType.SidebarFolder:
                    var folderToMove = dragData.folderToMove;
                    this.moveFolder(folderToMove, folderId);
                    break;
            }
        }
    };
    Dashboard.prototype.moveFolder = function (folderToMove, destinationFolder) {
        var dashboardFoldersViewStore = this.props.dashboardViewStore.dashboardFoldersViewStore;
        switch (destinationFolder) {
            case DashboardTypes_2.ProjectCollection.Archived:
                throw new Error("Archiving folders is not implemented yet");
            case DashboardTypes_2.ProjectCollection.Deleted:
                dashboardFoldersViewStore.onDeleteFolder(folderToMove);
                return;
            case DashboardTypes_2.ProjectCollection.All:
                destinationFolder = null;
                break;
        }
        dashboardFoldersViewStore.moveFolder(folderToMove, destinationFolder);
    };
    Dashboard.prototype.moveSelectedProjectsToFolder = function (folderId) {
        return __awaiter(this, void 0, Promise, function () {
            var dashboardViewStore;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dashboardViewStore = this.props.dashboardViewStore;
                        if (folderId === dashboardViewStore.selectedFolder) {
                            return [2];
                        }
                        return [4, this.resourceMover.moveResources(folderId, this.selectionStore.selected)];
                    case 1:
                        _a.sent();
                        this.stopAndDeselect();
                        return [2];
                }
            });
        });
    };
    var _a, _b, _c, _d, _e, _f, _g;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], Dashboard.prototype, "_componentWidth", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], Dashboard.prototype, "numSelectedProjects", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_a = typeof react_1.default !== "undefined" && react_1.default.ReactElement) === "function" ? _a : Object),
        __metadata("design:paramtypes", [])
    ], Dashboard.prototype, "renderProjectDragLabel", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], Dashboard.prototype, "onResize", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Dashboard.prototype, "useCompactLayout", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Dashboard.prototype, "backToStandardDashboard", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Dashboard.prototype, "clearTransientState", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Dashboard.prototype, "tryOpenLastSelectedFolder", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], Dashboard.prototype, "isUserFolderSelected", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Dashboard.prototype, "startDashboardDragging", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Dashboard.prototype, "startDrag", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Dashboard.prototype, "drag", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], Dashboard.prototype, "stopAndDeselect", void 0);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Dashboard.prototype, "onFolderSelect", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_d = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _d : Object, Number]),
        __metadata("design:returntype", void 0)
    ], Dashboard.prototype, "resourceDragStart", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_e = typeof react_1.default !== "undefined" && react_1.default.DragEvent) === "function" ? _e : Object, Object]),
        __metadata("design:returntype", void 0)
    ], Dashboard.prototype, "dragDropOnFolder", null);
    Dashboard = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], Dashboard);
    return Dashboard;
}(react_1.default.Component));
exports.default = Dashboard;
